
import * as React from 'react';

import { Heading, Icon, Text } from '@/components/ui';

export function SubmissionConfirmation () {
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-6 tw-my-12">
            <Icon icon="circleCheck" size="display" tone="primary" />
            <div className="tw-flex tw-flex-col tw-items-center tw-space-y-2">
                <Heading as="h2" variant="title-lg">
                    {i18next.t('signup.thank_you_for_applying')}
                </Heading>
                <div className="tw-max-w-md">
                    <Text tone="muted" variant="body">
                        {i18next.t('signup.application_received_message')}
                    </Text>
                </div>
            </div>
        </div>
    )
}
